import React, { Component } from 'react';
import { SmallButton } from "./common/Buttons";
import { ChooseMethod } from "./common/ChooseMethod";
import styled from 'styled-components';
import mfaTokenImg from "../images/Email_Img.png";
import { t } from "./helper/ClientAppLocalizer";
import retryImg from "../images/retry-ico.svg";
import { Button } from "react-bootstrap";
const StyledInput = styled.input`
  margin-top: 20px;
  width:320px;
`

export class EmailCode extends Component {
   

    constructor(props) {
        super(props);
        this.state = {
            code: "",
            isLoginEnabed: false
        };

        this.verifyCode = this.verifyCode.bind(this);
        this.setCode = this.setCode.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.SendEmailCode = this.SendEmailCode.bind(this);
    }

    componentDidMount() {
        this.SendEmailCode();
    }

    verifyCode() {
        const txtIncorrectCodeTryAgain = t("Email.IncorrectCodeTryAgain");

        fetch('/api/MFA/verifyEmailCode/' + this.state.code, { method: 'post' })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
                else {
                    throw new Error(results.statusText);
                }

            }).then(data => {
                if (data.success) {
                    this.setState({ errorMessage: "" });
                    this.props.verificationComplete(data);
                } else {
                    this.setState({ errorMessage: txtIncorrectCodeTryAgain });
                    this.props.allowRetry(data.allowRetry, txtIncorrectCodeTryAgain, data.returnUrl);
                }
            }).catch(error => {
                //"Error Verifying Authy Token");
                this.setState({ error: true });
            });
    }

    SendEmailCode() {

        fetch('/api/MFA/sendEmailVerificationRequest', {
            method: 'post',
            headers: new Headers({ 'content-type': 'application/json' }),
        })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
                else {
                    throw new Error(results.statusText);
                }

            })
            .then(data => {
                    this.setState({ codeSent: true });
                    this.props.requestSent(this.props.method);
            }).catch(error => {
                this.setState({ error: true });
            });
    }


    setCode(e) {
        this.setState({ code: e.target.value });
        this.setState({ isLoginEnabed: e.target.value.length >= 4 })
    }

    onKeyDown(e) {
        if (e.keyCode === 13) {
            this.verifyCode();
        }
    }

    render() {
        const enterTokenTxt = t("Email.EnterTokenFromEmail");
        const warn = t("SystemMessages.CommonWarning");
        const resendCodeText =t("PhoneCode.ResendCode");
        return (
            <div id="contentToken">
                <img id="topImage" alt="Ceridian Logo" src={mfaTokenImg} style={{ maxHeight: 120, maxWidth: 120, alignContent: 'center' }} />
                <h4 className="mfa-header">{enterTokenTxt}</h4>
                <p className="mfa-text" style={{ color: "black", fontWeight: "bold" }}>{warn}</p>
                <div>
                    <StyledInput id="authyTotpCode" type="text" onChange={this.setCode} onKeyDown={this.onKeyDown} maxLength="10" />
                </div>
                {this.state.errorMessage ? <div className="mfa-text" style={{ marginBottom: 10, color: 'red', fontSize: '70%' }}>{this.state.errorMessage}</div> : ''}
                <div style={{ marginTop: "20px" }}>
                    <SmallButton id="emailSubmit" onClick={this.verifyCode} disabled={!this.state.isLoginEnabed}>{t("Login")}</SmallButton>
                </div>
                <div>

                    <Button id="resendCodeBtn" variant="link" onClick={this.SendEmailCode} style={{ color: '#08c', fontSize: 12, fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif' }}>
                        <img src={retryImg} height="18" alt={t("PhoneCode.ResendCode")} />
                        {resendCodeText}
                    </Button>
                </div>
                <ChooseMethod changeVerificationMethod={this.props.changeVerificationMethod} lockoutMessage={this.props.lockoutMessage} />
            </div>
        );
    }
}